export const getIsFilterTagsLoading = (state) => state.filterTags.isTagsLoading;
export const getFilterTags = (state) => state.filterTags.filterTags;
export const getSelectedFilterTags = (state) => state.filterTags.selectedTags;
